import { Dynamic } from './dynamic';
export var VueDynamic = function (Vue, options) { var _a; return Vue.component(((_a = options) === null || _a === void 0 ? void 0 : _a.name) || 'Dynamic', Dynamic); };
if (typeof window !== 'undefined' && window.Vue) {
    // @ts-ignore
    window.Vue.use(VueDynamic);
}
export default VueDynamic;
export var install = VueDynamic;
export { Dynamic };
//# sourceMappingURL=index.js.map